// HubSpot Meeting Links Configuration
// Base URL: https://meetings-na2.hubspot.com/daniel-rivas
// 
// HOW TO CREATE SERVICE-SPECIFIC MEETING LINKS IN HUBSPOT:
// 1. Log in to HubSpot > Sales > Meetings
// 2. Click "Create meeting page"
// 3. Configure duration, availability, and form fields
// 4. Set a unique slug (e.g., "seo-strategy-call")
// 5. Copy the full URL and update this file
//
// Example: If you create a meeting with slug "seo-strategy-call",
// the full URL would be: https://meetings-na2.hubspot.com/daniel-rivas/seo-strategy-call

export const HUBSPOT_MEETING_BASE = "https://meetings-na2.hubspot.com/daniel-rivas";

// Meeting types for different services
// UPDATE THESE URLs after creating the specific meeting types in HubSpot
export const MEETING_LINKS = {
  // General consultation (default) - WORKING
  general: HUBSPOT_MEETING_BASE,
  
  // SEO Services
  // HubSpot Slug to create: "seo-strategy-call"
  seo: `${HUBSPOT_MEETING_BASE}/seo-strategy-call`,
  // HubSpot Slug to create: "local-seo-consultation"
  localSeo: `${HUBSPOT_MEETING_BASE}/local-seo-consultation`,
  
  // AEO & GEO Services
  // HubSpot Slug to create: "aeo-strategy-call"
  aeo: `${HUBSPOT_MEETING_BASE}/aeo-strategy-call`,
  // HubSpot Slug to create: "geo-strategy-call"
  geo: `${HUBSPOT_MEETING_BASE}/geo-strategy-call`,
  
  // Industry-specific meetings
  // HubSpot Slug to create: "gym-marketing-consultation"
  gym: `${HUBSPOT_MEETING_BASE}/gym-marketing-consultation`,
  // HubSpot Slug to create: "hvac-marketing-consultation"
  hvac: `${HUBSPOT_MEETING_BASE}/hvac-marketing-consultation`,
  // HubSpot Slug to create: "landscaping-marketing-consultation"
  landscaping: `${HUBSPOT_MEETING_BASE}/landscaping-marketing-consultation`,
  // HubSpot Slug to create: "law-firm-marketing-consultation"
  lawFirm: `${HUBSPOT_MEETING_BASE}/law-firm-marketing-consultation`,
  // HubSpot Slug to create: "healthcare-marketing-consultation"
  healthcare: `${HUBSPOT_MEETING_BASE}/healthcare-marketing-consultation`,
  // HubSpot Slug to create: "real-estate-marketing-consultation"
  realEstate: `${HUBSPOT_MEETING_BASE}/real-estate-marketing-consultation`,
  
  // AI Receptionist Demo
  // HubSpot Slug to create: "ai-receptionist-demo"
  aiReceptionist: `${HUBSPOT_MEETING_BASE}/ai-receptionist-demo`,
  
  // Video Marketing
  // HubSpot Slug to create: "video-marketing-consultation"
  videoMarketing: `${HUBSPOT_MEETING_BASE}/video-marketing-consultation`,
  
  // Web Design
  // HubSpot Slug to create: "web-design-consultation"
  webDesign: `${HUBSPOT_MEETING_BASE}/web-design-consultation`,
  
  // PPC/Ads
  // HubSpot Slug to create: "ppc-strategy-call"
  ppc: `${HUBSPOT_MEETING_BASE}/ppc-strategy-call`,

  // AI Operations & Implementation
  aiOperations: `${HUBSPOT_MEETING_BASE}/ai-operations-consultation`,
  aiLeadAgent: `${HUBSPOT_MEETING_BASE}/ai-lead-agent-demo`,
  aiContentEngine: `${HUBSPOT_MEETING_BASE}/ai-content-engine-demo`,
  aiInfluencerOutreach: `${HUBSPOT_MEETING_BASE}/ai-influencer-outreach-demo`,
  aiCoachingAgent: `${HUBSPOT_MEETING_BASE}/ai-coaching-agent-demo`,
  aiPostCallOps: `${HUBSPOT_MEETING_BASE}/ai-post-call-ops-demo`,
  aiKnowledgeAgent: `${HUBSPOT_MEETING_BASE}/ai-knowledge-agent-demo`,
};

// Helper function to get meeting link by service type
export const getMeetingLink = (serviceType = 'general') => {
  return MEETING_LINKS[serviceType] || MEETING_LINKS.general;
};

// Embed URL for inline calendar (Contact page)
export const getEmbedUrl = (meetingType = 'general') => {
  const link = getMeetingLink(meetingType);
  return `${link}?embed=true`;
};
